import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import AuthCallback from '@/pages/AuthCallback';
import SignUpPage from '@/pages/SignUpPage';
import LoginPage from '@/pages/LoginPage';
import BecomeATraveler from '@/pages/BecomeATraveler';
import Dashboard from '@/pages/Dashboard';
import SearchTravelers from '@/pages/SearchTravelers';
import TripDetails from '@/pages/TripDetails';
import CreateJourney from '@/pages/CreateJourney';
import CreateParcel from '@/pages/CreateParcel';
import Messages from '@/pages/Messages';
import Profile from '@/pages/Profile';
import UserTypeSelection from '@/pages/UserTypeSelection';
import RestrictedGoodsPage from '@/pages/RestrictedGoodsPage';
import KYC from '@/pages/KYC';
import Wallet from '@/pages/Wallet';
import PaymentReturn from '@/pages/PaymentReturn';
import Disputes from '@/pages/Disputes';
import DisputeDetail from '@/pages/DisputeDetail';
import AdminShell from '@/pages/admin/AdminShell';
import AdminOverview from '@/pages/admin/AdminOverview';
import RulesEditor from '@/pages/admin/RulesEditor';
import AdminDisputes from '@/pages/admin/AdminDisputes';
import TrustSafety from '@/pages/admin/TrustSafety';
import ProtectedRoute from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export { API, BACKEND_URL };

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/become-a-traveler" element={<BecomeATraveler />} />
      <Route path="/restricted-goods" element={<RestrictedGoodsPage />} />
      <Route path="/payment-return" element={<PaymentReturn />} />
      <Route path="/select-type" element={<ProtectedRoute><UserTypeSelection /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/kyc" element={<ProtectedRoute><KYC /></ProtectedRoute>} />
      <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
      <Route path="/search" element={<ProtectedRoute><SearchTravelers /></ProtectedRoute>} />
      <Route path="/trips/:tripId" element={<ProtectedRoute><TripDetails /></ProtectedRoute>} />
      <Route path="/trips/create" element={<ProtectedRoute><CreateJourney /></ProtectedRoute>} />
      <Route path="/parcels/create" element={<ProtectedRoute><CreateParcel /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/profile/:userId" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/disputes" element={<ProtectedRoute><Disputes /></ProtectedRoute>} />
      <Route path="/disputes/:dispute_id" element={<ProtectedRoute><DisputeDetail /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminShell /></ProtectedRoute>}>
        <Route index element={<AdminOverview />} />
        <Route path="rules" element={<RulesEditor />} />
        <Route path="trust-safety" element={<TrustSafety />} />
        <Route path="disputes" element={<AdminDisputes />} />
        <Route path="disputes/:dispute_id" element={<DisputeDetail adminContext />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
